import {combineReducers} from 'redux'
import login from './login'
import applications from './applications'
import entities from './entities'
import collection from './collection'
import linkedfield from './linkedfield'
import modules from './modules'
import relations from './relations'
import plannings from './plannings'
import record from './record'
import excel from './excel'
import publictables from './publictables'
import publicforms from './publicforms'
import sms from './sms'
import email from './email'
import messages from './messages'
import exportdata from './exportdata'
import statistics from './statistics'
import pdf from './pdf'
import scheduler from './scheduler'

const appReducer = combineReducers({
    login: login.reducer,
    applications: applications.reducer,
    entities: entities.reducer,
    collection: collection.reducer,
    linkedfield: linkedfield.reducer,
    modules: modules.reducer,
    relations: relations.reducer,
    plannings: plannings.reducer,
    record: record.reducer,
    excel: excel.reducer,
    publictables: publictables.reducer,
    publicforms: publicforms.reducer,
    sms: sms.reducer,
    email: email.reducer,
    messages: messages.reducer,
    exportdata: exportdata.reducer,
    statistics: statistics.reducer,
    pdf: pdf.reducer,
    scheduler: scheduler.reducer
})

const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT_FETCH_SUCCESS') {
        state = undefined
    }

    return appReducer(state, action)
}

export default rootReducer
